// @ts-nocheck
/**
 * 章タブコンポーネント
 */

import React from 'react';
import type { ChapterDisplayInfo } from '../data/types';
import { chapterTabStyles as styles, STATUS_ICONS } from '../styles/adventureStyles';

interface ChapterTabsProps {
  chapters: ChapterDisplayInfo[];
  selectedChapter: number;
  onSelectChapter: (chapterId: number) => void;
  isMobile?: boolean;
}

export const ChapterTabs: React.FC<ChapterTabsProps> = ({
  chapters,
  selectedChapter,
  onSelectChapter,
  isMobile = false,
}) => {
  return (
    <div style={styles.tabContainer}>
      {chapters.map((chapter) => {
        const isSelected = chapter.id === selectedChapter;
        const isLocked = !chapter.isUnlocked;
        const isComplete = chapter.progress.cleared >= chapter.progress.total;

        return (
          <button
            key={chapter.id}
            onClick={() => !isLocked && onSelectChapter(chapter.id)}
            style={{
              ...styles.tab,
              ...(isSelected ? styles.tabActive : {}),
              ...(isLocked ? styles.tabLocked : {}),
            }}
            disabled={isLocked}
          >
            <div>
              {isLocked ? STATUS_ICONS.locked : isComplete ? STATUS_ICONS.cleared : ''}
              {' '}第{chapter.id}章
            </div>
            {!isLocked && (
              <div style={styles.tabProgress}>
                {chapter.progress.cleared}/{chapter.progress.total}
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default ChapterTabs;
